<template>
  <div v-if="!props.vHtml" class="heading">
    <h1 v-if="props.level === '1'" :style="props.style" ><slot /></h1>
    <h2 v-else-if="props.level === '2'" :style="props.style" ><slot /></h2>
    <h3 v-else-if="props.level === '3'" :style="props.style" ><slot /></h3>
    <h4 v-else :style="props.style" ><slot /></h4>
  </div>
  <div v-else class="heading" :class="`heading_custom_${props.level}`">
    <component
      :is="tag || 'span'"
      :style="style"
      v-html="vHtml"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  level: string
  style?: Record<string, string>
  vHtml?: string,
  tag?: string
}
const props = defineProps<Props>();
</script>

<style scoped lang="scss">
@import "@/assets/scss/components/home/_heading.scss";
.heading {
  &.heading_custom_1 :deep(*) {
    font-family: 'DM Serif Text' !important;
    font-size: 40px !important;
    font-weight: 700 !important;
    color: #000000;
    line-height: 52.48px !important;
  }

  &.heading_custom_2 :deep(*) {
    font-family: 'DM Serif Text' !important;
    font-size: 32px !important;
    font-weight: 700 !important;
    color: #000000;
    line-height: 41.98px !important;
  }

  &.heading_custom_3 :deep(*) {
    font-family: 'Roboto' !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #000000;
    line-height: 20px !important;
  }

  &.heading_custom_4 :deep(*) {
    font-family: 'DM Serif Text' !important;
    font-size: 20px !important;
    font-weight: 700 !important;
    color: #000000;
    line-height: 26.24px !important;
  }

  @media screen and (max-width: 576px) {
    &.heading_custom_1 :deep(*) {
      font-size: 28px !important;
      line-height: 36.74px !important;
    }

    &.heading_custom_2 :deep(*) {
      font-size: 22px !important;
      line-height: 28.86px !important;
    }

    &.heading_custom_3 :deep(*) {
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 20px !important;
    }

    &.heading_custom_4 :deep(*) {
      font-size: 20px !important;
      line-height: 26.24px !important;
    }
  }
}
</style>